import React from 'react';

import { IFooter20Fields } from '../../../../types/contentful';

import { Layout, Column } from '../../Layout';

import { Navigation } from './Navigation';
import { Legal } from './Legal';
import { Social } from './Social';

import {
  FooterWrapper,
  FooterBlockContainer,
  FooterSocialColumn,
  LineBreakWrapper,
  LineBreak
} from './styles';

export function Footer2(props: IFooter20Fields) {
  const { isAffiliateFooter } = props;
  return (
    <FooterWrapper>
      <FooterBlockContainer
        id="footer"
        marginTop={{
          0: 'blockMarginY',
          tablet: 'blockMarginY_tablet',
          desktop: '3xl'
        }}
        borderRadius={{ 0: ['block', 'block', '0', '0'] }}
        backgroundColor="footerBg"
        revealOnScroll={false}
        isAffiliate={isAffiliateFooter as boolean}
        data-blockid="footer20"
        data-testid="footer20"
      >
        <Layout>
          <FooterSocialColumn
            size={{
              0: 12,
              desktop: isAffiliateFooter ? 12 : 4
            }}
            isAffiliate={isAffiliateFooter as boolean}
          >
            <Social {...props} />
          </FooterSocialColumn>

          {!isAffiliateFooter && (
            <LineBreakWrapper
              size={{ 0: 12, desktop: 0 }}
              flexDirection="column"
              marginTop="m"
              marginBottom="s"
            >
              <LineBreak />
            </LineBreakWrapper>
          )}

          {!isAffiliateFooter && (
            <Column size={{ 0: 12, desktop: 8 }} flexDirection="column">
              <Navigation {...props} />
            </Column>
          )}
        </Layout>
      </FooterBlockContainer>

      <Legal {...props} />
    </FooterWrapper>
  );
}
